import numeral from "numeral";

/**
 * Formatea un numero con numeral.js y lo envuelve en un <span>.
 *
 * Reemplaza a "react-numeral" (ver docs/UPGRADE-CORE-GALILEA.md, tarea 5.5
 * adelantada a la fase 2): ese paquete declara react@^15.3.2 como
 * dependencia real (no peer), asi que npm instalaba su propia copia
 * anidada de React 15. Al renderizar un elemento creado por esa copia
 * dentro del arbol de React 19 de la app, React 19 lo rechazaba en
 * runtime con "A React Element from an older version of React was
 * rendered" — un crash, no solo un warning.
 *
 * Mismos props que react-numeral (value, format, className) y mismo
 * comportamiento exacto, incluyendo el caso sin "format": reemplazo
 * verificado contra los 38 sitios de uso del proyecto, que solo pasan
 * los formatos "0,0" y "$0,0".
 *
 * Se exporta como default y como nombrado ("{ Numeral }") porque
 * react-numeral ofrecia ambas formas y el proyecto usaba las dos.
 */
function Numeral({ value, format, className }) {
  if (!value) return null;
  const formatted = format ? numeral(value).format(format) : numeral(value);
  return <span className={className || ""}>{formatted}</span>;
}

export { Numeral };
export default Numeral;
